import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { getUserSocialProfiles } from "@/backend/focus";
import type { UserSocialProfiles } from "@/contexts/user-context";
import { parseError } from "@/utils/helpers";
import {
  USER_SOCIAL_PROFILE_QUERY_KEY,
  USER_SOCIAL_PROFILES_CACHE_MAX_AGE_MS,
} from "@/utils/query-persistence";

type UseUserSocialProfileQueryOptions = Omit<
  UseQueryOptions<UserSocialProfiles | null>,
  "queryKey" | "queryFn"
>;

export const useUserSocialProfileQuery = (
  publicKey: string,
  options?: UseUserSocialProfileQueryOptions,
) => {
  return useQuery({
    queryKey: [USER_SOCIAL_PROFILE_QUERY_KEY, publicKey],
    queryFn: async () => {
      try {
        return getUserSocialProfiles(publicKey);
      } catch (error) {
        console.error("Error fetching user social profile:", parseError(error));
        throw error;
      }
    },
    gcTime: USER_SOCIAL_PROFILES_CACHE_MAX_AGE_MS,
    placeholderData: null,
    enabled: !!publicKey,
    refetchOnWindowFocus: false,
    staleTime: USER_SOCIAL_PROFILES_CACHE_MAX_AGE_MS,
    ...options,
  });
};
